export const POLL_POPUP_KEY = 'pollPopupClosedUntil'
